import Home from '@/views/home/index.vue'
import Login from '@/views/login/index.vue'
import exhibition from '@/views/login/exhibition.vue'
import Search from '@/views/search/index.vue'
import Disease from '@/views/disease/index.vue'
import DiseaseInfo from '@/views/disease/diseaseInfo.vue'
import DiseaseType from '@/views/disease/diseaseType.vue'
import Assessment from '@/views/assessment/index.vue'
import AssessmentAppraisal from '@/views/assessment/assessment.vue'
import AssessmentResult from '@/views/assessment/result.vue'
import AssessmentResultDetail from '@/views/assessment/resultDetail.vue'
import CurrentIndex from '@/views/current/index.vue'
import CurrentList from '@/views/current/currentList.vue'
import CurrentSubject from '@/views/current/currentSubject.vue'
import CurrentResult from '@/views/current/result.vue'
import Inherit from '@/views/inherit/index.vue'
import InheritInfo from '@/views/inherit/inheritInfo.vue'
import Rare from '@/views/rare/index.vue'
import RareInfo from '@/views/rare/rareInfo.vue'
import Drug from '@/views/drug/index.vue'
import DrugInfo from '@/views/drug/drugInfo.vue'
import DrugType from '@/views/drug/drugType.vue'
import Talent from '@/views/talent/index.vue'
import TalentInfo from '@/views/talent/talentInfo.vue'
import TalentType from '@/views/talent/talentType.vue'
// 祖源
import Source from '@/views/source/index.vue'
import Composition from '@/views/source/composition.vue'
import Haplotype from '@/views/source/haplotype.vue'
import Neanderthals from '@/views/source/neanderthals.vue'

// 重置密码
import ForgetPwd from '@/views/login/forgetPwd.vue'
// 修改密码
import UpdatePassword from '@/views/home/updatePassword.vue'

// 冠状病毒易感性评估
// import Coronavirus from '@/views/coronavirus/index.vue'
// import CoronavirusInfo from '@/views/coronavirus/coronavirusInfo.vue'

// 多组学
import Multiomics from '@/views/multiomics/index.vue'

// 神经酰胺
import Ceramide from '@/views/ceramide/index.vue'
import Protocol from '@/views/ceramide/protocol.vue'
import ProtocolContent from '@/views/ceramide/protocolContent.vue'
import Health from '@/views/ceramide/health.vue'
import Results from '@/views/ceramide/results.vue'
import HistoryInfo from '@/views/ceramide/historyInfo.vue'
import HealthDataPK from '@/views/ceramide/healthDataPK.vue'
import RiskFactors from '@/views/ceramide/riskFactors.vue'
import CerMoreInfo from '@/views/ceramide/cerMoreInfo.vue'

// 综合结论
import Conclusion from '@/views/conclusion/index.vue'

// 遗传携带
import Genetic from '@/views/genetic/index.vue'
import Coming from '@/views/genetic/coming.vue'
import GeneticReport from '@/views/genetic/geneticReport.vue'
import Geneprotocol from '@/views/genetic/geneprotocol.vue'
import GeneproContent from '@/views/genetic/geneproContent.vue'


// 20231204 小产品
import SmallHome from '@/views/smallProduct/home/index.vue'
import DeseaseDetails from '@/views/smallProduct/deseaseDetails/index.vue'

// 在侧边导航中显示的路由写在 appRouter 里
export const appRouter = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/exhibition',
    name: 'exhibition',
    component: exhibition,
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/search',
    name: 'search',
    component: Search,
    meta: { requiresAuth: true }
  },
  {
    path: '/disease',
    name: 'disease',
    component: Disease,
    query: { activeTab: 'activeTab' },
    meta: { requiresAuth: true }
  },
  {
    path: '/diseaseInfo/:id/:type',
    name: 'diseaseInfo',
    component: DiseaseInfo,
    meta: { requiresAuth: true }
  },
  {
    path: '/diseaseType/:id',
    name: 'diseaseType',
    component: DiseaseType,
    meta: { requiresAuth: true }
  },
  {
    path: '/inherit',
    name: 'inherit',
    component: Inherit,
    meta: { requiresAuth: true }
  },
  {
    path: '/inheritInfo/:id',
    name: 'inheritInfo',
    component: InheritInfo,
    meta: { requiresAuth: true }
  },
  {
    path: '/rare',
    name: 'rare',
    component: Rare,
    meta: { requiresAuth: true }
  },
  {
    path: '/rareInfo/:id',
    name: 'rareInfo',
    component: RareInfo,
    meta: { requiresAuth: true }
  },
  {
    path: '/drug',
    name: 'drug',
    component: Drug,
    query: { activeTab: 'activeTab' },
    meta: { requiresAuth: true }
  },
  {
    path: '/drugInfo/:id',
    name: 'drugInfo',
    component: DrugInfo,
    meta: { requiresAuth: true }
  },
  {
    path: '/drugType/:id',
    name: 'drugType',
    component: DrugType,
    meta: { requiresAuth: true }
  },
  {
    path: '/talent',
    name: 'talent',
    component: Talent,
    query: { activeTab: 'activeTab' },
    meta: { requiresAuth: true }
  },
  {
    path: '/talentInfo/:id',
    name: 'talentInfo',
    component: TalentInfo,
    meta: { requiresAuth: true }
  },
  {
    path: '/talentType/:id',
    name: 'talentType',
    component: TalentType,
    meta: { requiresAuth: true }
  },
  {
    path: '/assessment',
    name: 'assessment',
    component: Assessment,
    meta: { requiresAuth: true }
  },
  {
    path: '/assessmentAppraisal',
    name: 'assessmentAppraisal',
    component: AssessmentAppraisal,
    meta: { requiresAuth: true }
  },
  {
    path: '/assessmentResult',
    name: 'assessmentResult',
    component: AssessmentResult,
    meta: { requiresAuth: true }
  },
  {
    path: '/assessmentResultDetail/:name',
    name: 'assessmentResultDetail',
    component: AssessmentResultDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/currentIndex',
    name: 'currentIndex',
    component: CurrentIndex,
    meta: { requiresAuth: true }
  },
  {
    path: '/currentList',
    name: 'currentList',
    component: CurrentList,
    meta: { requiresAuth: true }
  },
  {
    path: '/currentSubject',
    name: 'currentSubject',
    query: { did: 'did' },
    component: CurrentSubject,
    meta: { requiresAuth: true }
  },
  {
    path: '/currentResult/:cid',
    name: 'currentResult',
    component: CurrentResult,
    meta: { requiresAuth: true }
  },
  {
    path: '/source',
    name: 'source',
    component: Source,
    meta: { requiresAuth: true }
  },
  {
    path: '/composition',
    name: 'composition',
    component: Composition,
    meta: { requiresAuth: true }
  },
  {
    path: '/haplotype/:parent',
    name: 'haplotype',
    component: Haplotype,
    meta: { requiresAuth: true }
  },
  {
    path: '/neanderthals',
    name: 'neanderthals',
    component: Neanderthals,
    meta: { requiresAuth: true }
  },
  {
    path: '/forgetPwd',
    name: 'forgetPwd',
    component: ForgetPwd,
    meta: { requiresAuth: true }
  },
  {
    path: '/updatePassword',
    name: 'updatePassword',
    component: UpdatePassword,
    meta: { requiresAuth: true }
  },
  {
    path: '/multiomics',
    name: 'multiomics',
    component: Multiomics,
    meta: { requiresAuth: true }
  },
  {
    path: '/ceramide',
    name: 'ceramide',
    component: Ceramide,
    meta: { requiresAuth: true }
  },
  {
    path: '/protocol',
    name: 'protocol',
    component: Protocol,
    meta: { requiresAuth: true }
  },
  {
    path: '/protocolContent',
    name: 'protocolContent',
    component: ProtocolContent,
    meta: { requiresAuth: true }
  },
  {
    path: '/health',
    name: 'health',
    component: Health,
    meta: { requiresAuth: true }
  },
  {
    path: '/results',
    name: 'results',
    component: Results,
    meta: { requiresAuth: true }
  },
  {
    path: '/historyInfo/:date/:scode',
    name: 'historyInfo',
    component: HistoryInfo,
    meta: { requiresAuth: true }
  },
  {
    path: '/healthDataPK',
    name: 'healthDataPK',
    component: HealthDataPK,
    meta: { requiresAuth: true }
  },
  {
    path: '/riskFactors',
    name: 'riskFactors',
    component: RiskFactors,
    meta: { requiresAuth: true }
  },
  {
    path: '/cerMoreInfo',
    name: 'cerMoreInfo',
    component: CerMoreInfo,
    meta: { requiresAuth: true }
  },
  {
    path: '/conclusion',
    name: 'conclusion',
    component: Conclusion,
    meta: { requiresAuth: true }
  },
  {
    path: '/genetic',
    name: 'genetic',
    component: Genetic,
    meta: { requiresAuth: true }
  },
  {
    path: '/coming',
    name: 'coming',
    component: Coming,
    meta: { requiresAuth: true }
  },
  {
    path: '/geneticReport',
    name: 'geneticReport',
    component: GeneticReport,
    meta: { requiresAuth: true }
  },
  {
    path: '/geneprotocol',
    name: 'geneprotocol',
    component: Geneprotocol,
    meta: { requiresAuth: true }
  },
  {
    path: '/geneproContent',
    name: 'geneproContent',
    component: GeneproContent,
    meta: { requiresAuth: true }
  },
  // {
  //   path: '/coronavirus',
  //   name: 'coronavirus',
  //   component: Coronavirus,
  //   meta: { requiresAuth: true }
  // },
  // {
  //   path: '/coronavirusInfo/:id',
  //   name: 'coronavirusInfo',
  //   component: CoronavirusInfo,
  //   meta: { requiresAuth: true }
  // }

  // 20231204 小产品
  {  // 小产品首页
    path: '/small/home',
    name: 'small_home',
    component: SmallHome,
    meta: { requiresAuth: true },
  },
  // path: '/diseaseInfo/:id/:type',
  { // 疾病详情
    path: '/desease/details/:type/:scode/:id',
    name: 'desease_details',
    component: DeseaseDetails,
    meta: { requiresAuth: true },
  }
]

export const Routers = [
  ...appRouter
]



// WEBPACK FOOTER //
// ./src/router/routers.js